import React, { useCallback } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { ValidationErrorsMessage } from '../../../../../../common/types';

interface IgnoreLinkCellRendererProps extends ICellRendererParams {
  handleIgnoreButtonClick: (errorDetails: ValidationErrorsMessage) => void;
}

const IgnoreLinkCellRenderer = (props: IgnoreLinkCellRendererProps) => {
  const {
    handleIgnoreButtonClick,
    value,
    node: { data },
  } = props;

  const handleOnClick = useCallback(() => {
    handleIgnoreButtonClick(data);
  }, [data, handleIgnoreButtonClick]);

  return (
    <button type="button" className="a-btn a-btn-transparent a-btn-sm" onClick={handleOnClick}>
      {value || 'Ignore Validation'}
    </button>
  );
};

export default IgnoreLinkCellRenderer;
